import { Icon } from '@/general/Icons/Icon';

import { FilterName } from '@/plp/components/FilterName/FilterName';

import { FilterOption, PlpFilterBaseItemProps, PlpFiltersConditionalProps } from '../PlpFilters.type';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';
import { PlpFiltersRange } from '../components/PlpFiltersRange/PlpFiltersRange';

type Props = Prettify<
  PlpFilterBaseItemProps & {
    options: {
      minOptions: FilterOption[];
      maxOptions: FilterOption[];
    };
    minValue: string | number;
    maxValue: string | number;
  } & PlpFiltersConditionalProps
>;

export const FilterTowCapacityBraked = ({
  options,
  minValue,
  maxValue,
  index,
  showNotificationBadge,
  ...props
}: Props) => {
  const id = 'tow';
  const header = (
    <FilterName
      icon={<Icon name="tow-cap-braked" />}
      label="Tow (braked)"
      showNotificationBadge={showNotificationBadge}
    />
  );
  const content = (
    <PlpFiltersRange
      minOptions={options.minOptions}
      maxOptions={options.maxOptions}
      minValue={minValue}
      maxValue={maxValue}
      minPlaceholder="From"
      maxPlaceholder="To"
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
